import React, { useState } from 'react';
import { Button, Grid, TextField } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';

const MetaDataComponent = ({ onBack }) => {
    const [documentName, setDocumentName] = useState('');
    const [url, setUrl] = useState('');
    const [description, setDescription] = useState('');

    return (
        <MainCard title="Tất cả tài liệu / Tài liệu trợ lý A / Meta data tài liệu">
            <Grid item xs={12} sm={6} sx={{ textAlign: 'left' }}>
                <Button variant="outlined" color="secondary" onClick={onBack}>
                    Quay lại
                </Button>
            </Grid>
            <TextField
                label="Tên tài liệu"
                fullWidth
                value={documentName}
                onChange={(e) => setDocumentName(e.target.value)}
                margin="normal"
            />

            <TextField label="URL" fullWidth value={url} onChange={(e) => setUrl(e.target.value)} margin="normal" />

            <TextField
                label="Mô tả"
                fullWidth
                multiline
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                margin="normal"
            />
        </MainCard>
    );
};

export default MetaDataComponent;
